import { notification } from 'antd';
//@ts-ignore
import { saveAs } from 'file-saver';
import { base64ToArrayBuffer } from '../shared/utils';
import { PdfReport } from './types';

/**
 * Saves one rendered report as a file, and tells the user when it never arrived. Rendering runs
 * while the user waits and can be refused or cut short, so a click that produces neither a file
 * nor a word would look like a button that does nothing.
 *
 * Every report type is downloaded the same way and differs only in what it asks the render engine
 * for, which is what `renderReport` carries.
 */
export default async function downloadPdfReport(renderReport: () => Promise<PdfReport>) {
    try {
        const report = await renderReport();

        const pdfBlob = new Blob([base64ToArrayBuffer(report.pdf_content)], { type: 'application/pdf' });

        saveAs(pdfBlob, report.file_name);
    } catch (error) {
        notification.error({ message: 'Could not download the PDF', description: 'Please try again or contact support!' });
    }
}
